import { BlitsError } from "./blits.error";

export class ConfigurationError extends BlitsError {

    static CODE = "configuration_error";

    constructor(message?: string) {
        super(ConfigurationError.CODE, message || `Failed to execute action due to a configuration error.`);
    }
}